module.exports = __webpack_public_path__ + "002f805c4dc9faa860e05d3e69a3d675.pdf";